var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list ajusteAcoesPesquisar" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "grid-component",
        {
          attrs: {
            columns: _vm.gridColumns,
            data: _vm.gridData,
            extraActions: _vm.extraActions,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            "show-action-column": true,
            "show-edit-item": false,
            "show-remove-item": false,
            "show-select-checkbox": true,
            "show-table-head": true,
            showAddNewButton: true,
            total: _vm.total,
            gerarPDFNaApi: true,
            gerarXLSNaApi: true,
          },
          on: {
            "gerar-PDF-Api": _vm.downloadPDF,
            "gerar-XLS-Api": _vm.downloadXLS,
            "change-page-size": _vm.onChangePageSize,
            "change-page": _vm.onChangePage,
            "extra-action": _vm.onExtraAction,
            "selected-values-changed": _vm.onSelectedValuesChanged,
            "change-filter-key": _vm.onChangeFilterKey,
          },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "filtro-lista" }, [
              _c(
                "button",
                {
                  staticClass: "filtro-avancado-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.isHidden = !_vm.isHidden
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                      "\n                    "
                  ),
                  _c("i", { staticClass: "fa fa-caret-down" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isHidden,
                      expression: "isHidden",
                    },
                  ],
                  staticClass: "drop-lista",
                },
                [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "novalidate" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.load($event)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "tipoVendaId" },
                                },
                                [_vm._v("Tipo de Venda")]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "tipoVendaId",
                                  name: "tipoVendaId",
                                  data: _vm.tipoVendaOptions,
                                },
                                model: {
                                  value: _vm.tipoVendaId,
                                  callback: function ($$v) {
                                    _vm.tipoVendaId = $$v
                                  },
                                  expression: "tipoVendaId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "emissaoDe" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.dataInicialDaAprovacao"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: { id: "emissaoDe", name: "emissaoDe" },
                                model: {
                                  value: _vm.emissaoDe,
                                  callback: function ($$v) {
                                    _vm.emissaoDe = $$v
                                  },
                                  expression: "emissaoDe",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "emissaoAte" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.dataFinalDaAprovacao"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: { id: "emissaoAte", name: "emissaoAte" },
                                model: {
                                  value: _vm.emissaoAte,
                                  callback: function ($$v) {
                                    _vm.emissaoAte = $$v
                                  },
                                  expression: "emissaoAte",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "dataEntregaDe" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.dataInicialDaEntrega"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: {
                                  id: "dataEntregaDe",
                                  name: "dataEntregaDe",
                                },
                                model: {
                                  value: _vm.dataEntregaDe,
                                  callback: function ($$v) {
                                    _vm.dataEntregaDe = $$v
                                  },
                                  expression: "dataEntregaDe",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "dataEntregaAte" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.dataFinalDaEntrega"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: {
                                  id: "dataEntregaAte",
                                  name: "dataEntregaAte",
                                },
                                model: {
                                  value: _vm.dataEntregaAte,
                                  callback: function ($$v) {
                                    _vm.dataEntregaAte = $$v
                                  },
                                  expression: "dataEntregaAte",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "localEntregaId" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.localEntrega"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "localEntregaId",
                                  name: "localEntregaId",
                                  data: _vm.locaisEntregaOptions,
                                },
                                model: {
                                  value: _vm.localEntregaId,
                                  callback: function ($$v) {
                                    _vm.localEntregaId = $$v
                                  },
                                  expression: "localEntregaId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.setorOptions.length > 0
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-12" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "setorId" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.setor"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("combo-component", {
                                    attrs: {
                                      id: "setorId",
                                      name: "setorId",
                                      data: _vm.setorOptions,
                                    },
                                    model: {
                                      value: _vm.setorId,
                                      callback: function ($$v) {
                                        _vm.setorId = $$v
                                      },
                                      expression: "setorId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "transportadoraId" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.transportadora"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "transportadoraId",
                                  name: "transportadoraId",
                                  data: _vm.transportadoraOptions,
                                },
                                model: {
                                  value: _vm.transportadoraId,
                                  callback: function ($$v) {
                                    _vm.transportadoraId = $$v
                                  },
                                  expression: "transportadoraId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "vendedor" },
                                },
                                [_vm._v("Vendedor")]
                              ),
                              _vm._v(" "),
                              _c("combo-component", {
                                attrs: {
                                  id: "vendedor",
                                  name: "vendedor",
                                  data: _vm.vendedoresOptions,
                                },
                                model: {
                                  value: _vm.vendedorId,
                                  callback: function ($$v) {
                                    _vm.vendedorId = $$v
                                  },
                                  expression: "vendedorId",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "dataFaturamentoDe" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Data de Faturamento Inicial\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: {
                                  id: "dataFaturamentoDe",
                                  name: "dataFaturamentoDe",
                                },
                                model: {
                                  value: _vm.dataFaturamentoDe,
                                  callback: function ($$v) {
                                    _vm.dataFaturamentoDe = $$v
                                  },
                                  expression: "dataFaturamentoDe",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "dataFaturamentoAte" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        Data de Faturamento Final\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-time-picker-component", {
                                attrs: {
                                  id: "dataFaturamentoAte",
                                  name: "dataFaturamentoAte",
                                },
                                model: {
                                  value: _vm.dataFaturamentoAte,
                                  callback: function ($$v) {
                                    _vm.dataFaturamentoAte = $$v
                                  },
                                  expression: "dataFaturamentoAte",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  staticStyle: { "margin-top": "5px" },
                                  attrs: { for: "statusEntrega" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.emissaoNotaTransporteLote.list_vue_html.somenteComNFSe"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("checkbox-component", {
                                attrs: {
                                  id: "somenteComNFSe",
                                  name: "somenteComNFSe",
                                },
                                model: {
                                  value: _vm.somenteComNFSe,
                                  callback: function ($$v) {
                                    _vm.somenteComNFSe = $$v
                                  },
                                  expression: "somenteComNFSe",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "botao-filtrar",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("__.Crud.filtrar")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.gridSelectedValues.length > 0,
                  expression: "gridSelectedValues.length > 0",
                },
              ],
              attrs: { slot: "footer-extra-options" },
              slot: "footer-extra-options",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.emitirNotasLote },
                },
                [_vm._v("Emitir em Lote")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("configuracoesImpresaoXLSComponent", {
        ref: "configuracoesImpresaoXLSComponent",
        on: { onConfirm: _vm.onConfirmXLS },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-div" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v("Emissao em Lote de Nota Fiscal de Transporte"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }